<template>
    <sub-page class="m-editTheoryImageTopic">
        <el-form
            :model="topicForm"
            :rules="topicRules"
            class="topic-form"
            ref="topicForm"
            :label-width="$i18n.locale === 'zh-CN' ? '120px': '180px'">

            <el-form-item class="rt-form-item" :label="$t('topic.questionDesc')+'：'" required>
                <quill-editor v-model="titleRT" ref="titleRT"></quill-editor>
            </el-form-item>

            <el-form-item class="image-group" label="考试图片：">
                <div class="image-area">
                    <div class="ratio">
                        <div class="img-box">
                            <img :src="topicForm.picSrcUrl" alt="考试图片">
                        </div>
                    </div>
                    <el-tag class="image-tag" type="primary" size="small">考试图片</el-tag>
                </div>
                <div class="image-area">
                    <div class="ratio">
                        <image-marker
                            ref="imageMarker"
                            :imageUrl="imageUrl"
                            :imageMark="imageMark"
                            :disabled="topicForm.isSafe"
                        ></image-marker>
                    </div>
                    <el-tag v-if="topicForm.isSafe" class="image-tag" type="success" size="mini" dark>答案图（安全）</el-tag>
                    <el-tag v-else class="image-tag" type="danger" size="mini">答案图（嫌疑）</el-tag>
                    <p class="tips">* 可对答案图片的标框进行修改</p>
                </div>

            </el-form-item>

            <div class="select-group">
                <el-form-item :label="$t('c.operatorLevel')+'：'" prop="forLevel">
                    <el-select v-model="topicForm.forLevel" :placeholder="$t('tip.operatorLevel')" style="width:200px;">
                        <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('c.difficulty')+'：'" prop="difficulty">
                    <el-select v-model="topicForm.difficulty" :placeholder="$t('tip.difficulty')" style="width:200px;">
                        <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('c.knowledgePoint')+'：'" prop="knowledge">
                    <el-cascader
                        v-model="topicForm.knowledge"
                        :options="knowledgeMenu['Theory']"
                        :props="cascadeProp"
                        :show-all-levels="false"
                        style="width:200px;"
                    ></el-cascader>
                </el-form-item>
            </div>

            <el-form-item label=" " class="analysis">
                <el-collapse v-model="activeNames" accordion>
                    <el-collapse-item :title="$t('topic.addOrEditAnalyse')" name="1">
                        <quill-editor v-model="analysisRT" ref="analysisRT"></quill-editor>
                    </el-collapse-item>
                </el-collapse>
            </el-form-item>
        </el-form>

        <div class="btn-group">
            <el-button @click="$router.back()" size="medium">取消</el-button>
            <el-button type="primary" @click="saveTopicForm" size="medium" :loading="topicLoading">{{ $t('c.save') }}
            </el-button>
        </div>
    </sub-page>
</template>

<script>
import {mapGetters} from 'vuex';
import {Cascade} from '@/utils';
import SubPage from '@/components/Subpage';
import QuillEditor from "@/components/QuillEditor"
import ImageMarker from "@/components/Image/ImageMarker"

export default {
    components: {
        SubPage,
        QuillEditor,
        ImageMarker
    },

    data() {
        return {
            activeNames: '0',
            cascadeProp: {
                value: 'id',
                label: 'value',
                children: 'children'
            },
            topicForm: {
                difficulty: '',
                forLevel: '',
                knowledge: [],
            },
            topicLoading: false,
            topicRules: {
                forLevel: [
                    {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                ],
                difficulty: [
                    {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                ],
                knowledge: [
                    {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                ],
            },
            difficultyDict: [],

            titleRT: '',
            analysisRT: '',
            imageUrl: '',
            imageMark: []
        }
    },

    mounted() {
        this.$store.dispatch('getForLevelMenu');
        this.$store.dispatch('getKnowledgeMenu', {
            type: 'Theory'
        })

        this.$api.getDifficulty().then(res => {
            this.difficultyDict = res.package
        });

        this.initEditData();
    },
    computed: {
        ...mapGetters([
            'forLevelMenu',
            'knowledgeMenu'
        ]),
    },
    methods: {
        async initEditData() {
            this.topicID = this.$route.query['id']
            this.topicIndex = this.$route.query['idx']

            let res = await this.$api.getTheoryTopicDetail(this.topicID)
            this.topic = res.package

            this.topicForm = {
                difficulty: this.topic.difficulty,
                forLevel: this.topic.forLevel,
                knowledge: Cascade.fullPath(this.knowledgeMenu['Theory'], this.topic.knowledge),
                picSrcUrl: this.topic.picSrcUrl,
                picViewUrl: this.topic.picViewUrl,
                height: this.topic.height,
                width: this.topic.width,
                isSafe: this.topic.isSafe,
                pattern: this.topic.pattern
            }

            // 加载编辑器信息
            this.titleRT = this.topic.titleRT
            this.analysisRT = this.topic.analysisRT

            // 加载图像信息
            setTimeout(() => {
                this.imageUrl = this.topic.picSrcUrl
                this.imageMark = this.topic.rectangleOptions
            }, 200)

        },

        saveTopicForm() {
            this.title = this.$refs.titleRT.quill.getText()

            this.$refs['topicForm'].validate((valid) => {
                if (!valid) {
                    $('.el-main').scrollTop(0);
                    return
                }

                if (!this.title.trim()) {
                    this.$message.error(this.$t('tip.titleDesc') + '！');
                    return
                }

                this.submitRequest().catch(e => {
                    console.error(e)
                    this.topicLoading = false
                })
            });
        },

        async submitRequest() {
            // 标图数据
            let rectangleOptions = this.$refs.imageMarker.getUserMarkedRectanglesInfo()

            if (!this.topicForm.isSafe && !rectangleOptions.length) {
                return this.$message.error('请在图像中标记嫌疑物位置！')
            }

            // todo 判断是否改了标框数据 改了再请求
            // 【Request1: 如果修改了框的数据，就重新生成图片】
            let tags = rectangleOptions.map(item => {
                let rectangleArr = item.rectangle.split(',')

                return {
                    tag: item.answerName,
                    rectangle: {
                        x: rectangleArr[0],
                        y: rectangleArr[1],
                        x2: rectangleArr[2],
                        y2: rectangleArr[3],
                    }
                }
            })

            let newRes = await this.$api.mergeGraphic({
                url: this.topic.picSrcUrl,
                tags
            })
            this.topicForm.picViewUrl = newRes.message

            // 【Request2：提交修改】
            let data = Object.assign({}, this.topicForm, {
                title: this.title,
                titleRT: this.titleRT,
                analysis: this.$refs.analysisRT.quill.getText(),
                analysisRT: this.analysisRT,
                knowledge: this.topicForm.knowledge[this.topicForm.knowledge.length - 1],
                rectangleOptions
            });

            this.topicLoading = true

            await this.$api.editTheoryGraphicTopic(this.topicID, data)

            // 【request3：获取详情】
            let res = await this.$api.getTheoryTopicDetail(this.topicID)
            let newData = res.package

            console.log(this.topicIndex)
            if (this.topicIndex !== undefined) {
                this.$emit('onSave', newData, this.topicIndex);
            }

            this.$message.success(this.$t('m.editSuccess'))
            this.topicLoading = false;
            this.$router.back();
        }
    },
}
</script>

<style lang="scss">

@import '~@style/const.scss';

.m-editTheoryImageTopic {

    .topic-form {
        width: 90%;
        @media screen and (min-width: 1920px) {
            width: 75%;
        }
    }

    .select-group {
        margin-bottom: 10px;

        .el-form-item {
            display: inline-block;
        }
    }

    .image-group {
        //display: flex;
        //padding-left: 40px;
        //margin-bottom: 32px;
        padding: 10px 0;

        > .el-form-item__content {
            display: flex;
        }

        .image-area {
            flex: 1;
            position: relative;
            //width: 500px;
            //height: 320px;
            border: 1px solid #ccc;

            + .image-area {
                margin-left: 20px;
                //border: 1px solid $green;
            }

            .ratio {
                padding-top: 75%;
            }

            .image-marker-container {
                position: absolute !important;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            .img-box {
                @extend .image-marker-container;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }

        .image-tag {
            position: absolute;
            right: 0;
            top: 0;
        }

        .tips {
            font-size: 12px;
            color: #999;
            line-height: 2;
            transform: translateY(100%);
        }
    }

    .el-select-dropdown__item {
        width: 200px;
    }

    .btn-group {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 10px 0;
        text-align: center;
        background-color: #fff;
        border-top: 1px solid #eee;
        box-shadow: 0 2px 8px #ccc;

        button {
            letter-spacing: 4px;

            + button {
                margin-left: 15px;
            }
        }
    }

    .analysis {
        padding-bottom: 30px;
        margin-bottom: 0;

        > .el-form-item__content {
            //width: 80%;
        }

        .el-collapse,
        .el-collapse-item__wrap {
            border: none;
        }

        .el-collapse-item {
            border: dashed 1px #2e7faa;

            &.is-active {
                border-left: none;
                border-right: none;
            }
        }

        .el-collapse-item__header {
            font-size: 15px;
            height: 32px;
            line-height: 32px;
            color: #2e7faa;
            text-align: center;
            border: none;
        }

        .el-collapse-item__arrow {
            float: none;
            display: inline-block;
            line-height: 32px;
        }
    }

    .el-form-item__label {
        color: $c-txt;
    }

    .rt-form-item {
        .el-form-item__label {
            line-height: 1;
            padding-top: 10px;
        }

        .el-form-item__content {
            line-height: 1;
        }
    }

    .quill-editor {
        //width: 80%;
        .ql-editor {
            height: 80px;
        }
    }


    .cheat-wrap {
        position: absolute;
        right: 10%;
        top: 20px;
    }

    .cheat-wrap button {
        padding: 8px 20px;
        margin-right: 20px;
        font-size: 18px;
        outline: none;
        border: none;
        cursor: pointer;
    }

    .cheat-list {
        padding-top: 20px;
    }
    .cheat-list h3 {
        margin-bottom: 10px;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
}
</style>
